<!-- Нейтральное пояснение под заголовком страницы или вкладками раздела. -->
<template>
  <p class="base-page-hint">
    <AppIcon
      name="info"
      :size="18"
      class="base-page-hint__icon"
      aria-hidden="true"
    />
    <span class="base-page-hint__text"><slot /></span>
  </p>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BasePageHint",
  components: { AppIcon },
};
</script>

<style scoped>
.base-page-hint {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 var(--base-in-indent);
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid var(--color-grey);
  background: var(--color-light);
  color: color-mix(in srgb, var(--color-dark) 65%, var(--color-light));
  font-size: 14px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.base-page-hint__icon {
  flex-shrink: 0;
  margin-top: 1px;
  color: inherit;
}
.base-page-hint__text {
  min-width: 0;
}
</style>
